module.exports = __webpack_public_path__ + "static/media/introduction.bfb0ce89.png";